'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.persistUserLocation = persistUserLocation;

var _effects = require('redux-saga/effects');

var _timeAndDate = require('constants/time-and-date');

var _locale = require('redux/modules/locale');

var _localStorage = require('./local-storage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(persistUserLocation);

function persistUserLocation(lat, lon) {
  return _regenerator2.default.wrap(function persistUserLocation$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(!lat || !lon)) {
            _context.next = 2;
            break;
          }

          return _context.abrupt('return');

        case 2:
          _context.prev = 2;
          _context.next = 5;
          return (0, _effects.put)((0, _locale.setUserSelectedLocation)(lat, lon));

        case 5:
          _context.next = 7;
          return (0, _effects.call)(_localStorage.writeLocalStorage, 'userLocation', {
            lat: lat,
            lon: lon,
            expires: Date.now() + _timeAndDate.DAY_MS * 30
          });

        case 7:
          _context.next = 11;
          break;

        case 9:
          _context.prev = 9;
          _context.t0 = _context['catch'](2);

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[2, 9]]);
}